import { render, staticRenderFns } from "./feeModifyList.vue?vue&type=template&id=638380c4&scoped=true"
import script from "./feeModifyList.vue?vue&type=script&lang=js"
export * from "./feeModifyList.vue?vue&type=script&lang=js"
import style0 from "./feeModifyList.vue?vue&type=style&index=0&id=638380c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638380c4",
  null
  
)

export default component.exports